import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";

export const cancelFunding = createAsyncThunk<void, string, { extra: Partial<Dependencies> }>(
  "fundingRequests/cancelFunding",
  async (fundingRequestId: string, { extra: { adminRepository } }) => {
    return adminRepository!.cancelFunding(fundingRequestId);
  },
);

export const resetCancelFunding = createAction("fundingRequests/resetCancelFunding");
